angular.module('project')
    .component('projectStaging', {
        bindings: {
            projectId: '<'
        },
        templateUrl: 'app/project/project-staging.html',
        controller($scope, $state, Project, ProjectService, modals) {
            this.ProjectService = ProjectService;

            this.$onChanges = () => {
                Project.getStaging({id: this.projectId}).$promise.then(data => this.item = data);
            }

            this.edit = () => {
                modals.open('app/project/project-staging-edit.html', 'ProjectStagingEditController', {id: this.projectId}, {size: "lg"}, "$ctrl").then(() => this.$onChanges())
            }
        }
    })

    .controller('ProjectStagingEditController', function ($http, toastr, modals, $scope, $rootScope, $uibModalInstance, data, Project, InvoiceService) {
        this.$onInit = () => {
            this.projectId = data.id
            Project.getStaging({id: data.id}).$promise.then(result => {
                this.item = result
                this.calculateTotal()
            })
        }
        this.add = () => {
            this.item.items.push({})
        }
        this.remove = ($index) => {
            this.item.items.splice($index, 1)
            this.calculateTotal()
        }
        this.calculateTotal = () => {
            this.total = InvoiceService.sumDecimal(this.item.items.map(item => item.percent));
            this.totalLeft = 100 - this.total;
        }
        this.onAmountChanged = (item) => {
            this.calculateTotal()
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.delete = () => {
            return modals.confirmDelete("harmonogram projektu", () => Project.deleteStaging({id: data.id}).$promise.then(() => {
                $rootScope.$broadcast('project.updated', null);
                $uibModalInstance.close();
            }));
        }
        this.save = () => {
            let form = {
                id: data.id,
                ...this.item
            }
            return Project.saveStaging(form).$promise.then(result => {
                $rootScope.$broadcast('project.updated', result);
                $uibModalInstance.close(result);
            })
        }
        this.constructionLogFileChanged = (item, file) => {
            item.constructionLogFile = file
        }
        this.customersNotificationFileChanged = (item, file) => {
            item.customersNotificationFile = file
        }
    })
